import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import * as queries from 'lib/graphql/queries';
import { i18n } from 'lib/i18n.js';
import storefront from 'lib/storefront';
import { convertGQLToProductJson, isMobile, htmlDecode } from 'utils/general';
import on, { off } from 'dom-event';
import debounce from 'lodash.debounce';
import { trackEvent } from '../../assets/js/lib/tracking';
import { A11y, Keyboard } from 'swiper/modules';

export default {
  i18n,
  components: {
    'vue-image': () => import('../vue-image/vue-image.vue'),
    'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
    'vue-swiper': () => import('../vue-swiper/vue-swiper.vue'),
  },
  data() {
    return {
      product: {},
      showModal: false,
      isModalActive: false,
      images: [],
      isFirstRendered: true,
      isMobile: isMobile(),
      swiperOptions: {
        slidesPerView: 'auto',
        grabCursor: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        a11y: true,
        keyboard: true,
        modules: [
          A11y, Keyboard
        ],
        breakpoints: {
          768: {
            centeredSlides: false,
            loop: true,
          }
        },
        on: {
          slideChange: () => {
            trackEvent({
              event: 'product_module_interaction',
              click_action: 'swipe',
              product_name: htmlDecode(this.product?.title),
              site_section: window.__GLOBAL__.siteSection,
              component_name: 'Bundle Builder Product Image Gallery',
              shopify_module_name: 'bundle builder gallery'
            })
          }
        }
      }
    };
  },
  mounted() {
  },
  created() {
    window.addEventListener('bb-product-card:gallery', this.openModal);
  },
  beforeDestroy() {
    window.removeEventListener('bb-product-card:gallery', this.openModal);
  },
  methods: {
    openModal(e) {
      this.showModal = true;
      document.body.classList.add('gallery-open');

      this.fetchProductData(e.detail.handle).then(() => {
        setTimeout(() => {
          this.isModalActive = true;
          document.body.classList.add('scroll-lock');
        }, 800);
      });
    },
    closeModal() {
      this.isModalActive = false;
      clearAllBodyScrollLocks();
      document.body.classList.remove('scroll-lock');
      setTimeout(() => {
        this.showModal = false;
        document.body.classList.remove('gallery-open');
      }, 300);
    },
    async fetchProductData(handle) {
      const storefrontResponse = await storefront.request(queries.product, {
        handle,
      });

      const convertedProduct = convertGQLToProductJson(
        storefrontResponse.product,
      );
      this.product = convertedProduct;
      this.images = convertedProduct.media.filter(
        (media) => media.type === 'image',
      );
      this.product.shortDescription = this.getShortDescription(this.product);
    },
    goToSlide(index) {
      this.$refs.carousel.swiper().slideTo(index);
    },
    getShortDescription(product) {
      if (
        product.variants[0].shortDescription &&
        product.variants[0].shortDescription !== 'false'
      ) {
        return htmlDecode(product.variants[0].shortDescription);
      }
      if (product.shortDescription && product.shortDescription !== 'false') {
        return product.shortDescription;
      }
      if (
        product.collectionShortDescription &&
        product.collectionShortDescription !== 'false'
      ) {
        return htmlDecode(product.collectionShortDescription);
      }
      return false;
    },
  },
};
